import {SimpleSlider} from '../../../components/slider.tsx';
import styles from './features_slider.module.scss';
import {FeatureCard} from './feature_card.tsx';
import {__, transString} from '../../../support/lang/translations.ts';

export function FeaturesSlider() {
    return (
        <div className={styles.features_slider}>
            <div className={styles.features_slider__title}>
                <h2>{__('dashboard.titles.features')}</h2>
            </div>
            <SimpleSlider className={'dashboard-features-slider'} slides={3} infinite={false}>
                <FeatureCard icon="fa-light fa-car-alt" title={transString('nav.occasions')} to="occasions" />
                <FeatureCard icon="fa-light fa-calendar-days" title={transString('nav.appointment')} to="appointment" />
                <FeatureCard icon="fa-light fa-phone" title={transString('nav.contact')} to="contact" />
                <FeatureCard icon="fa-light fa-newspaper" title={transString('nav.news')} to="news" />
                <FeatureCard icon="fa-light fa-star" title={transString('nav.reviews')} to="reviews" />
                <FeatureCard icon="fa-light fa-exclamation-triangle" title={transString('nav.damage')} to="damage" />
                <FeatureCard icon="fa-light fa-lightbulb" title={transString('nav.faults')} to="faults" />
            </SimpleSlider>
        </div>
    );
}
